import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FooterLinkComponent } from '../footer-link/footer-link.component';
import { FooterRouterLinkComponent } from '../footer-router-link/footer-router-link.component';
import { Route } from '@web/common';

@Component({
  selector: 'app-footer-second-column',
  imports: [FooterLinkComponent, FooterRouterLinkComponent],
  templateUrl: './footer-second-column.component.html',
  styleUrl: './footer-second-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterSecondColumnComponent {
  protected readonly Route = Route;
}
